import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import HeadLogo from "./assets/LogoWeb.png";
import Gif from "./assets/banner.gif";
import CrazyLogo from "./assets/crazyLogo.png";
import Twitter from "./assets/twittericon.png";
import Discord from "./assets/discordicon.png";
import Instagram from "./assets/instagramicon.png";
import { MintCountdown } from "./MintCountdown";
import App from './App';

import "./index.css";

const date = new Date("21 Aug 2022 17:11:00 GMT");

ReactDOM.render(
  <React.StrictMode>
    <div className="Main">
      <div className="HeadLogo">
        <img src={HeadLogo} alt="DOPE DRAGONS" className="Logo" />
      </div>
      <div className="Gif-container">
        <img src={Gif} alt="Dope Dragons Sample" className="Gif" />
      </div>
      <div
        style={{
          width: "250px",
          marginLeft: "auto",
          marginRight: "auto",
          textAlign: "center",
        }}
      >
        {" "}
        <h3 style={{ color: "white", fontWeight: "bold" }}>MINT STARTS IN :</h3>
        <MintCountdown
          key="goLive"
          date={date}
          style={{ justifyContent: "center" }}
          status="LIVE"
        />
      </div>
      <App/>

      <div className="CrazyLogo">
        <a
          href="https://www.crazylabcrew.com/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={CrazyLogo} alt="CrazyLabCrew" className="Crazy" />
        </a>
        <div>
          <span className="Quote">Brought by CrazyLabCrew</span>
        </div>
      </div>
      <div className="Socials">
        <a
          href="https://twitter.com/CrazyLabCrew"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Twitter} alt="Twitter" className="SocialLogo" />
        </a>
        <a
          href="https://discord.gg/5WADv5AU2R"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Discord} alt="Discord" className="SocialLogo" />
        </a>
        <a
          href="https://www.instagram.com/crazylabcrew_nft/"
          target="_blank"
          rel="noreferrer"
        >
          <img src={Instagram} alt="Instagram" className="SocialLogo" />
        </a>
      </div>
    </div>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
